import Exemptions from "./exemptions.jsx"

export default Exemptions